import { useEffect, useState } from "react";


export const VideoHome = () => {





    return (

        process.env.REACT_APP_URL_TEST === "true" &&
        <div className='text-black dark:text-white bg-[#000]  text-wrap break-all '>



            SECCION VIDEO YOUTUBE MARCOS HABLANDO A CAMARA. guion en ingles.


        </div>


    )
}

